import { createSelector } from 'reselect'

export default createSelector(
	[
		state => state.drawIt.entityUID,
		state => state.drawIt.timer.value,
	],
	(entityUID, timerValue) => ({
		entityUID,
		timerValue,
	})
)
